import React from 'react';

const PUBLIC_URL = process.env.PUBLIC_URL || '';

function Card({ card, onClick }) {
    const handleClick = () => {
        onClick(card);
    };

    return (
        <div className={`card-wrapper ${card.isMatched ? 'matched' : ''}`}>
            {/* CSS 3D flip animation : la carte bascule sur 3D quand isFlipped est true */}
            <div className={`card ${card.isFlipped ? 'flipped' : ''}`} onClick={handleClick}>
                <div className="card-inner">
                    {/* L'image de dos (cache le front jusqu'au flip) */}
                    <img src={`${PUBLIC_URL}/images/back.webp`} alt="back" className="card-face card-back" />

                    {/* L'image du front (emoji) visible après le flip */}
                    <img src={card.image} alt={card.name} className="card-face card-front" />
                </div>
            </div>
        </div>
    );
}

export default Card;
